import * as z from "zod/v4";

export const getAiReturnReasonsForProduct = {
  name: "getAiReturnReasonsForProduct" as const,
  input: z.object({ productId: z.string() }),
  output: z.object({ reasons: z.array(z.string()) }),
};
